/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */
( function( app ) {
  const COMPONENT = {
    init: function() {
      $( '.navbar-toggle' ).on( 'toggleAfter', ( event ) => {
        $( '.primary-nav' ).slideToggle();
      } );

      $( '.js-init-video' ).magnificPopup( {
        type: 'iframe',
        mainClass: 'mfp-fade',
        removalDelay: 160,
        preloader: false,
        fixedContentPos: false,
        callbacks: {
          open: function() {
            $( 'video' ).trigger( 'pause' );
          },
          close: function() {
            $( 'video' ).trigger( 'play' );
          },
        },
      } );

      if ( $( '.navbar .announcement-banner' ).length && !localStorage.getItem( 'mmHideAnnouncement' ) ) {
        $( '.announcement-banner' ).show();
        const root = document.querySelector( ':root' );
        const navbarHeight = parseInt( getComputedStyle( document.documentElement ).getPropertyValue( '--navbarHeight' ) );
        const topOffset = getComputedStyle( document.documentElement ).getPropertyValue( '--topOffset' );
        const announcementBannerHeight = parseInt( $( '.navbar .announcement-banner' ).outerHeight() );

        const newNavbarHeight = ( navbarHeight + announcementBannerHeight ) + 'px';
        const newTopOffset = topOffset.slice( 0, -1 ) + ' + ' + announcementBannerHeight + 'px)';

        root.style.setProperty( '--navbarHeight', newNavbarHeight );
        root.style.setProperty( '--topOffset', newTopOffset );
        root.style.setProperty( '--announcementBannerHeight', announcementBannerHeight + 'px' );
      }

      $( '.announcement-banner .close' ).on( 'click', function() {
        const root = document.querySelector( ':root' );
        const navbarHeight = getComputedStyle( document.documentElement ).getPropertyValue( '--navbarHeight' );
        const topOffset = getComputedStyle( document.documentElement ).getPropertyValue( '--topOffset' );
        const announcementBannerHeight = getComputedStyle( document.documentElement ).getPropertyValue( '--announcementBannerHeight' );

        const newNavbarHeight = ( parseInt( navbarHeight ) - parseInt( announcementBannerHeight ) ) + 'px';
        const newTopOffset = topOffset.replace( ' + ' + parseInt( announcementBannerHeight ) + 'px', '' );

        $( '.announcement-banner' ).remove();
        root.style.setProperty( '--announcementBannerHeight', '0px' );
        root.style.setProperty( '--navbarHeight', newNavbarHeight );
        root.style.setProperty( '--topOffset', newTopOffset );
        localStorage.setItem( 'mmHideAnnouncement', true );
      } );

      function handleMobileChange( event ) {
        /*
         * Remove any inline display values when the screen changes
         * between mobile and desktop state. This allows the default
         * stylings to kick in and prevent any weird "half mobile half desktop"
         * nav display states that sometimes occur while resizing the browser
         * Also remove any active is-open classes from the toggle and nav to reset
         * its state when switching between screen sizes
         */
        if ( event.matches ) {
          if ( $( '.primary-nav' ).length > 0 ) {
            $( '.primary-nav' ).get( 0 ).style.removeProperty( 'display' );

            $( '.navbar-toggle, .primary-nav' ).removeClass( 'is-open' );
          }
        }
      }

      /* Run the handleMobileChange function when the screen sizes changes based on the mobileSize const */
      const mobileSize = window.matchMedia( '(min-width: 768px)' );
      handleMobileChange( mobileSize );
      mobileSize.addEventListener( 'change', handleMobileChange );

      /* Allow selects to have placeholder styles */
      checkSelectPlaceholder();
      $( '.gfield_select' ).on( 'change', function() {
        checkSelectPlaceholder();
      } );
      function checkSelectPlaceholder() {
        if ( $( '.gfield_select' ).find( 'option:selected' ).hasClass( 'gf_placeholder' ) ) {
          $( '.gfield_select' ).addClass( 'placeholder-selected' );
        } else {
          $( '.gfield_select' ).removeClass( 'placeholder-selected' );
        }
      }

      /* Lazyload all embeds */
      if ( 'IntersectionObserver' in window ) {
        const options = {
          root: null, // avoiding 'root' or setting it to 'null' sets it to default value: viewport
          rootMargin: '0px 0px 100px', // determines how far form the root the intersection callback will trigger
        };
        const embedObserver = new IntersectionObserver( function( entries, observer ) {
          entries.forEach( function( embed ) {
            if ( embed.isIntersecting ) {
              $( embed.target ).attr( 'src', $( embed.target ).attr( 'data-src-defer' ) );
              // remove observer
              embedObserver.unobserve( embed.target );
            }
          } );
        }, options );

        // add the observer to the elements
        $( '[data-src-defer]' ).each( function( index, element ) {
          embedObserver.observe( element );
        } );
      }

      if ( $( '.form-skin .ll-file-upload' ).length > 0 && typeof( gform ) !== 'undefined' ) {
        $( 'input[type=\'file\']' ).change( function() {
          const fullPath = $( this ).val();
          let filename = fullPath.replace( /^.*[\\/]/, '' );
          if ( filename === '' ) {
            filename = 'No file chosen';
          }
          const theInput = $( this ).parent().find( '.ll-file-upload span' );
          $( theInput ).text( filename );
        } );
      }

      $( '.gf_page_steps' ).each( function( key, val ) {
        setTimeout( function() {
          const startPosition = $( val ).find( '.gf_step_first' ).position();
          const startMid = $( val ).find( '.gf_step_first' ).width() / 2;
          const endPosition = $( val ).find( '.gf_step_last' ).position();
          const endMid = $( val ).find( '.gf_step_last' ).width() / 2;
          const progressWidth = ( endPosition.left + endMid ) - ( startPosition.left + startMid ) - 32;

          $( val ).append( '<div class="progress-line"></div>' );
          $( val ).find( '.progress-line' ).width( progressWidth );
        }, 150 );
      } );

      $( document ).on( 'gform_page_loaded', function( event, formId, currentPage ) {
        if ( $( '.quoter-form' ).length > 0 ) {
          $( '.quoter-form' ).removeClass( 'is-loading' );

          if ( currentPage == $( '.gform_page' ).length ) {
            $( '.multi-page-form__footer .button-area .llgq-quoter-next' ).hide();
            $( '.multi-page-form__footer .button-area .llgq-quoter-submit' ).show();
          } else {
            $( '.multi-page-form__footer .button-area .llgq-quoter-next' ).show();
            $( '.multi-page-form__footer .button-area .llgq-quoter-submit' ).hide();
          }
        }

        $( '.gf_page_steps' ).each( function( key, val ) {
          const startPosition = $( val ).find( '.gf_step_first' ).position();
          const startMid = $( val ).find( '.gf_step_first' ).width() / 2;
          const endPosition = $( val ).find( '.gf_step_last' ).position();
          const endMid = $( val ).find( '.gf_step_last' ).width() / 2;
          const progressWidth = ( endPosition.left + endMid ) - ( startPosition.left + startMid ) - 32;

          $( val ).append( '<div class="progress-line"></div>' );
          $( val ).find( '.progress-line' ).width( progressWidth );
        } );
      } );

      $( document ).on( 'click', '.quoter-form .gform_previous_button, .quoter-form .gform_next_button', function() {
        $( '.quoter-form' ).addClass( 'is-loading' );
      } );

      $( '.start-quoter' ).on( 'click', function() {
        $( '.multi-page-form__intro, .multi-page-form' ).addClass( 'is-started' );
      } );

      $( '.multi-page-form__footer .button-area .llgq-quoter-submit' ).on( 'click', function() {
        $( '.quoter-form input[type="submit"]' ).trigger( 'click' );
      } );

      const currentURL = location.pathname;
      $( '.module-group-links button' ).on( 'toggleAfter', function( event ) {
        let newURL = currentURL + '?group=' + $( event.target ).attr( 'data-toggle-target' ).replace( '#group-', '' );

        if ( $( event.target ).text() == 'View All' ) {
          newURL = currentURL;
        }

        window.history.replaceState( currentURL, $( '.single-module' ).attr( 'data-title' ) + ' - ' + $( event.target ).text(), newURL );
      } );
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'common', COMPONENT );
} )( app );
